// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { disposeMesh } from 'src/utils/object3DHelpers';
import { Inputs, SceneComponent, ComponentInteractionType } from './types';

export class ShadowComponent extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private plane: any = null;

  inputs: Inputs = {
    opacity: 0.2,
  };

  // setting which events are compatible with the component
  events = {
    [ComponentInteractionType.CLICK]: false,
    [ComponentInteractionType.HOVER]: false,
    [ComponentInteractionType.DRAG]: false,
  };

  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    // setting the collider to add the click event
    this.outputs.collider = this.root;
    this.root.add(this.pivot);

    this.outputs.objectRoot = this.root;

    this.makePlane();
  }

  onDestroy() {
    if (this.plane) {
      disposeMesh(this.plane);
      this.plane = null;
    }
  }

  // Called back when any inputs properties change like localPosition or localRotation
  onInputsUpdated() {
    // the plane resets at this.makePlane();
    this.onInit();
  }

  private makePlane() {
    if (this.plane) {
      disposeMesh(this.plane);
      this.plane = null;
    }

    const THREE = this.context.three;
    const { opacity } = this.inputs;

    const geometry = new THREE.PlaneGeometry(30, 30);
    geometry.rotateX(-Math.PI / 2);
    const material = new THREE.ShadowMaterial({
      opacity,
      depthWrite: false,
    });
    // // for debug:
    // const material = new THREE.MeshBasicMaterial({
    //   color: 0x00ff00,
    //   blending: THREE.NormalBlending,
    //   transparent: true,
    //   opacity: 0.4,
    //   depthWrite: false,
    // });
    this.plane = new THREE.Mesh(geometry, material);
    this.plane.position.y = 0.01;
    this.plane.receiveShadow = true;
    this.pivot.add(this.plane);
  }
}

export const shadowComponentType = 'mp.shadowComponent';
export const makeShadowComponent = (): any => new ShadowComponent();
